import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'ParagraphTitle',
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    paragraph: {
      type: Array,
      required: true
    }
  }
};